import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from 'src/app/aps-service.service';

@Component({
  selector: 'app-memberdirectory',
  templateUrl: './memberdirectory.component.html',
  styleUrls: ['./memberdirectory.component.css']
})
export class MemberdirectoryComponent implements OnInit {
  p: number = 1;
    loaderdata:any=false
  sub:any
  Username:any;
  name:any;
  email:any;
  phone:any;
  
  eventpagenumber: any;
  limit: any=10;
  pages: any;
  dataexist: boolean;
  last: number=0;
  next: number;
  previous: number;
  data: any;
  list:any;
  pageinationslist:any=1
  counter:any=1;
pagination:any=true

  constructor(private router: Router,private toastr: ToastrService,private route: ActivatedRoute,private searchitem: ApsServiceService) { }
form = new FormGroup({
    search: new FormControl('',Validators.required),
  });

  get search(): any { return this.form.get('search'); }


  ngOnInit(): void {
    this.getmembersdata()
  }

  getmembersdata(){
    this.pagination=true

    this.loaderdata=true
    this.eventpagenumber = this.pageinationslist
    //console.log(this.eventpagenumber)
    this.searchitem.getMembers(this.eventpagenumber,this.limit).subscribe((responce) => {
      if(responce.status){
        this.dataexist=true
      this.pages=parseInt(responce.totalitems)

      this.last=Math.ceil(this.pages/this.limit)

      if(responce.next){
        this.next=parseInt(responce.next)

      }else{
        this.next=0
      }
      if(responce.previous){
        this.previous=parseInt(responce.previous)
      }else{
        this.previous=0;
      }

      //console.log(responce.totalitems)
    //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
    this.data=responce.data
    //console.log(this.data)
  }else{
    this.dataexist=false

  }
  this.loaderdata=false
    })
  }
clicksearch(){
  this.searchitem.getMemberssearch(this.eventpagenumber).subscribe((responce) => {
    if(responce.status){
      this.dataexist=true
    this.pages=parseInt(responce.totalitems)

    this.last=Math.ceil(this.pages/this.limit)

    if(responce.next){
      this.next=parseInt(responce.next)

    }else{
      this.next=0
    }
    if(responce.previous){
      this.previous=parseInt(responce.previous)
    }else{
      this.previous=0;
    }

    //console.log(responce.totalitems)
  //  this.data = this.sanitizer.bypassSecurityTrustHtml(responce.data[0].event_details);  
  this.data=responce.data
  //console.log(this.data)
}else{
  this.dataexist=false

}
this.loaderdata=false
  })
}

clicknext(nextpage){
  this.loaderdata=true
  //console.log(nextpage)
  //console.log("lasts")
  //console.log(this.last)
  //console.log("next")
  //console.log(this.next)
  if(this.next!=0){
  this.counter= (this.pageinationslist * this.limit) + 1
  //console.log("counter")
  //console.log(this.counter)
  this.pageinationslist= this.next
  this.getmembersdata()
  }else{
    this.loaderdata=false
  }
 
}


clickprev(nextpage){
  this.loaderdata=true
  //console.log(nextpage)
  //console.log("lasts")
  //console.log(this.last)
  //console.log("next")
  //console.log(this.next)
  if(this.previous!=0){
  this.counter= (this.counter - this.limit) 
  //console.log("counter")
  //console.log(this.counter)
  this.pageinationslist= this.previous
  this.getmembersdata()
  }else{
    this.loaderdata=false
  }
 
}

clearInputMethod1() { this.search.reset(); }
getsearchitem() {
  if (!this.form.valid) {
    //console.log( this.form.get('search'));
    this.toastr.warning('Feed has no items')
  } else {
    this.loaderdata=true
    //console.log('hii')
    //console.log( this.form.get('search').value);
    //console.log(this.form.value);

    
    this.searchitem.getMemberssearch(this.form.get('search').value).subscribe((responces)=>{
      //console.log(responces)
      if(responces.status){
        // this.clearInputMethod1()
        this.data=responces.datas
        this.pagination=false
        this.loaderdata=false
        this.counter = 1
        //  this.datas=responces.datas
        // this.inputName.nativeElement.value = '';
      }else{
        this.toastr.info('No Username Found')
        this.loaderdata=false
      }    
    })

  }
}



}
